/** Homepage banner carousel loop helpers. Rendering clones only — API/data unchanged. */

export function buildLoopSlides(banners) {
  const list = Array.isArray(banners) ? banners : [];
  if (list.length <= 1) {
    return { slides: list, loopable: false, startIndex: 0 };
  }
  return {
    slides: [list[list.length - 1], ...list, list[0]],
    loopable: true,
    startIndex: 1,
  };
}

export function realBannerIndex(loopIndex, count, loopable) {
  if (!count) return 0;
  if (!loopable) return Math.min(Math.max(0, loopIndex), count - 1);
  if (loopIndex <= 0) return count - 1;
  if (loopIndex >= count + 1) return 0;
  return loopIndex - 1;
}

export function nextLoopIndex(loopIndex, count, loopable) {
  if (!loopable || count <= 1) return 0;
  if (loopIndex >= count + 1) return loopIndex;
  return loopIndex + 1;
}

export function prevLoopIndex(loopIndex, count, loopable) {
  if (!loopable || count <= 1) return 0;
  if (loopIndex <= 0) return loopIndex;
  return loopIndex - 1;
}

export function snapLoopIndex(loopIndex, count, loopable) {
  if (!loopable || count <= 1) return { index: loopIndex, snap: false };
  if (loopIndex >= count + 1) return { index: 1, snap: true };
  if (loopIndex <= 0) return { index: count, snap: true };
  return { index: loopIndex, snap: false };
}

export function trackOffsetPercent(loopIndex, slideCount) {
  if (!slideCount) return 0;
  return (loopIndex * 100) / slideCount;
}

export function loopSlideKey(banner, originalIndex, role) {
  const base = banner?.id || banner?.title || String(originalIndex);
  if (role === 'head') return `${base}__loop-head`;
  if (role === 'tail') return `${base}__loop-tail`;
  return String(base);
}
